import CONFIG from 'Config/settings';

const { COUNTRY, LANGUAGE } = CONFIG;

const getProfileUrl = (url = '') => {
  return `${window.location.origin}/${COUNTRY}/${LANGUAGE}/profile/${url}`;
};

export default {
  PROFILE: getProfileUrl(),
  DASHBOARD: getProfileUrl('dashboard/'),
  LOGIN: getProfileUrl('login/'),
  LOGOUT: getProfileUrl('logout/'),
  SEND_OTP: getProfileUrl('send-otp/'),
  ERROR: getProfileUrl('error/'),
  RESET_PASSWORD: getProfileUrl('reset/'),
  ROOT: '/'
};

export const QUERY_PARAMS = {
  FROM: 'from',
  SHOW_UPGRADE: 'showUpgrade',
  REDIRECT_TO_AFTER_UPGRADE: 'redirectToAfterUpgrade',
  TRANSLATE: 'TRANSLATE',
  ICW: 'icw',
  UTM_SOURCE: 'utm_source',
  UTM_MEDIUM: 'utm_medium',
  UTM_CAMPAIGN: 'utm_campaign',
  ITM_CAMPAIGN: 'itm_campaign',
  ITM_ELEMENT: 'itm_element',
  ITM_CONTENT: 'itm_content'
};
